var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-data"},[_c('h4',{staticClass:"user-data__key"},[_c('span',{staticClass:"user-data__icon"},[_c('i',{class:_vm.userDataIcon})]),_c('strong',[_vm._v(_vm._s(_vm.userDataKey)+":")])]),_c('p',{staticClass:"user-data__value"},[_vm._v(" "+_vm._s(_vm.formatUserDataValue(_vm.userDataValue))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }